// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ybnAUOohdkYeHcbXkTbG{border-top:1px solid var(--border-neutral-default);padding:4px}.j9caJaOn0sLlr1PrsMt0{padding:8px 12px 4px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dropdownItemWrap": `ybnAUOohdkYeHcbXkTbG`,
	"label": `j9caJaOn0sLlr1PrsMt0`
};
export default ___CSS_LOADER_EXPORT___;
